import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
	Row,
	Col,
	Card,
	CardBody,
	CardHeader,
	Container,
	Button,
	Table,
	FormGroup,
	InputGroup,
	InputGroupAddon,
	Input,
	Pagination,
	PaginationItem,
	PaginationLink,
} from "reactstrap";

import swal from "sweetalert";
import {
	getQuality,
	qualityAdd,
	qualityEdit,
	qualityDelete,
	model_open,
	model_close,
	SetParams,
} from "../../../store/Masters/quality/actions";

class quality extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		console.log("Quality component mounted - fetching with params");
		this.props.getQuality({
			...this.props.params,
			page: 1,
			search: "",
		});
	}

	handleDelete(values) {
		this.props.qualityDelete(values, this.props.history);
	}

	deleteRecord = (record) => {
		swal({
			title: "Are you sure?",
			text: "Once deleted, you will not be able to recover this imaginary file!",
			icon: "warning",
			buttons: true,
			dangerMode: true,
		}).then((willDelete) => {
			if (willDelete) {
				this.handleDelete(record.id);
			} else {
				swal({ title: "Your imaginary file is safe!", timer: 1500 });
			}
		});
	};

	handleSearch = (e) => {
		if (e.key === "Enter") {
			this.props.getQuality({
				...this.props.params,
				page: 1,
				search: e.target.value,
			});
		}
		if (e.target.value === "") {
			this.props.getQuality(
				{
					...this.props.params,
					search: "",
					page: 1,
				},
				true
			);
		}
	};

	openPage(pageNo) {
		this.props.SetParams({ ...this.props.params, page: pageNo });
		this.props.getQuality({ ...this.props.params, page: pageNo });
	}

	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						<Row>
							<Col xs={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom">
										<Link to="/MastersDashboard">
											<i className="ri-arrow-go-back-fill font-size-18"></i>
										</Link>
										<h5 className="card-title-18 d-inline-block ml-2">
											Quality Master
										</h5>

										<div className="float-right">
											<Button
												type="button"
												color="primary"
												className="waves-effect waves-light"
												onClick={() => {
													this.props.model_open();
												}}>
												Add Quality
											</Button>
										</div>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md={4}>
												<FormGroup className="m-0">
													<InputGroup>
														<Input
															type="text"
															name="search"
															className="form-control d-inline-block"
															placeholder="Search"
															validate={{
																required: true,
															}}
															onChange={(e) =>
																this.props.SetParams(
																	{
																		...this
																			.props
																			.params,
																		search: e
																			.target
																			.value,
																		page: 1,
																	}
																)
															}
															onKeyDown={(e) =>
																this.handleSearch(
																	e
																)
															}
														/>
														<InputGroupAddon addonType="append">
															<Button
																color="light"
																type="submit"
																onClick={() =>
																	this.props.getQuality(
																		{
																			...this
																				.props
																				.params,
																			page: 1,
																		}
																	)
																}>
																<i className="ri-search-line"></i>
															</Button>
														</InputGroupAddon>
													</InputGroup>
												</FormGroup>
											</Col>
											<Col md={8}>
												<div className="float-right">
													<Pagination aria-label="Page navigation example">
														<PaginationItem
															disabled={
																this.props
																	.params
																	.page <= 1
															}>
															<PaginationLink
																onClick={(e) =>
																	this.openPage(
																		1
																	)
																}
																first
															/>
														</PaginationItem>

														{this.props.params
															.page > 2 && (
															<PaginationItem
																disabled={
																	this.props
																		.params
																		.page <=
																	2
																}>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			this
																				.props
																				.params
																				.page -
																				2
																		)
																	}>
																	{this.props
																		.params
																		.page -
																		2}
																</PaginationLink>
															</PaginationItem>
														)}
														{this.props.params
															.page > 1 && (
															<PaginationItem
																disabled={
																	this.props
																		.params
																		.page ===
																	1
																}>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			this
																				.props
																				.params
																				.page -
																				1
																		)
																	}>
																	{this.props
																		.params
																		.page -
																		1}
																</PaginationLink>
															</PaginationItem>
														)}

														<PaginationItem
															active={true}>
															<PaginationLink
																onClick={() =>
																	this.openPage(
																		this
																			.props
																			.params
																			.page
																	)
																}>
																{
																	this.props
																		.params
																		.page
																}
															</PaginationLink>
														</PaginationItem>
														{this.props.params
															.page +
															1 <=
															this.props.params
																.no_of_pages && (
															<PaginationItem
																disabled={
																	this.props
																		.params
																		.page +
																		1 >
																	this.props
																		.params
																		.no_of_pages
																}>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			this
																				.props
																				.params
																				.page +
																				1
																		)
																	}>
																	{this.props
																		.params
																		.page +
																		1}
																</PaginationLink>
															</PaginationItem>
														)}
														{this.props.params
															.page +
															2 <=
															this.props.params
																.no_of_pages && (
															<PaginationItem
																disabled={
																	this.props
																		.params
																		.page +
																		2 >
																	this.props
																		.params
																		.no_of_pages
																}>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			this
																				.props
																				.params
																				.page +
																				2
																		)
																	}>
																	{this.props
																		.params
																		.page +
																		2}
																</PaginationLink>
															</PaginationItem>
														)}
														{this.props.params
															.page +
															3 <=
															this.props.params
																.no_of_pages &&
															this.props.params
																.page < 3 && (
																<PaginationItem
																	disabled={
																		this
																			.props
																			.params
																			.page +
																			3 >
																		this
																			.props
																			.params
																			.no_of_pages
																	}>
																	<PaginationLink
																		onClick={() =>
																			this.openPage(
																				this
																					.props
																					.params
																					.page +
																					3
																			)
																		}>
																		{this
																			.props
																			.params
																			.page +
																			3}
																	</PaginationLink>
																</PaginationItem>
															)}
														{this.props.params
															.page +
															4 <=
															this.props.params
																.no_of_pages &&
															this.props.params
																.page < 2 && (
																<PaginationItem
																	disabled={
																		this
																			.props
																			.params
																			.page +
																			4 >
																		this
																			.props
																			.params
																			.no_of_pages
																	}>
																	<PaginationLink
																		onClick={() =>
																			this.openPage(
																				this
																					.props
																					.params
																					.page +
																					4
																			)
																		}>
																		{this
																			.props
																			.params
																			.page +
																			4}
																	</PaginationLink>
																</PaginationItem>
															)}

														<PaginationItem
															disabled={
																this.props
																	.params
																	.no_of_pages ===
																this.props
																	.params.page
															}>
															<PaginationLink
																onClick={(e) =>
																	this.openPage(
																		this
																			.props
																			.params
																			.no_of_pages
																	)
																}
																last
															/>
														</PaginationItem>
													</Pagination>
												</div>
											</Col>
										</Row>
										<div
											className="table-responsive m-0"
											style={{
												maxHeight: "550px",
												overflowY: "auto",
											}}>
											<Table
												bordered
												hover
												responsive
												className="mb-0 p-0 table-centered">
												<thead className="bg-light text-center">
													<tr>
														<th className="nowrap">
															Code
														</th>
														<th className="nowrap">
															Name
														</th>
														<th className="nowrap">
															Actions
														</th>
													</tr>
												</thead>
												<tbody>
													{this.props.qualitylist
														.length !== 0 ? (
														<>
															{this.props.qualitylist.map(
																(
																	row,
																	key
																) => (
																	<tr
																		key={
																			key
																		}>
																		<td className="text-center">
																			{
																				row.code
																			}
																		</td>
																		<td>
																			{
																				row.name
																			}
																		</td>
																		<td className="nowrap text-center">
																			<i
																				className="mdi mdi-pencil-box-outline mr-2 font-size-18"
																				title="Edit Quality"
																				style={{
																					cursor: "pointer",
																					color: "#fc6f03",
																				}}
																				onClick={() =>
																					this.props.qualityEdit(
																						row
																					)
																				}></i>

																			<i
																				className="mdi mdi-delete mr-2 font-size-18"
																				title="Delete Quality"
																				style={{
																					cursor: "pointer",
																					color: "#ff0000",
																				}}
																				onClick={() =>
																					this.deleteRecord(
																						row
																					)
																				}></i>
																		</td>
																	</tr>
																)
															)}
														</>
													) : (
														<>
															<tr>
																<td
																	colSpan="3"
																	className="text-center">
																	<span className="font-size-18 text-danger">
																		Data not
																		available
																	</span>
																</td>
															</tr>
														</>
													)}
												</tbody>
											</Table>
										</div>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { qualitylist, model, rowdata, params } = state.quality;
	return { qualitylist, model, rowdata, params };
};

export default connect(mapStatetoProps, {
	getQuality,
	qualityAdd,
	qualityEdit,
	qualityDelete,
	model_open,
	model_close,
	SetParams,
})(quality);
